module.exports = __webpack_public_path__ + "static/media/r375.e28b9776.jpg";